export default "__VITE_ASSET__59207972__"